module.exports = {
    props: ['user'],
    /**
     * The component's data.
     */
    data() {
        return {
            form: $.extend(true, new SparkForm({
                watermark_enabled: '',
                screenshot_timestamp: '',
            }), Spark.forms.lkqPreferences),
            watermarkImage: ''
        };
    },
    /**
     * Bootstrap the component.
     */
    mounted() {
        this.form.watermark_enabled = this.user.watermark_enabled;
        this.form.screenshot_timestamp = this.user.screenshot_timestamp;
    },
    computed: {
        /**
         * Calculate the style attribute for the photo preview.
         */
        previewStyle: function previewStyle() {
            let bg = '';
            if (this.watermarkImage === '') {
                bg = 'background-image: url(' + this.user.watermark_image_url + ')';
            } else {
                bg = 'background-image: url(' + this.watermarkImage + ')';
            }
            return bg;
        }
    },
    methods: {
        updateWatermark(e) {
            e.preventDefault();
            if ( ! this.$refs.image.files.length) {
                return;
            }
            const file = this.$refs.image.files[0];
            const reader = new FileReader();
            reader.onload = (e) => {
                this.watermarkImage = e.target.result;
            };
            reader.readAsDataURL(file);
        },
        /**
         * Update the user's contact information.
         */
        update(e) {
            e.preventDefault();
            let formData = this.gatherFormData();
            this.form.startProcessing();
            axios.post(`/settings/preferences/screenshot`, formData)
                .then(() => {
                    Bus.$emit('updateUserData');
                    this.form.finishProcessing();
                }).catch((error) => {
                    this.form.setErrors(error.response.data.errors);
                });
        },
        /**
         * Gather the form data for the photo upload.
         */
        gatherFormData() {
            const data = new FormData();
            if (! this.watermarkImage == '') {
                data.append('watermark_image', this.$refs.image.files[0]);
            }
            data.append('watermark_enabled', String(!!this.form.watermark_enabled))
            data.append('screenshot_timestamp', String(!!this.form.screenshot_timestamp))
            return data;
        }
    }
};
